import { ESupportedGames } from "../../@types";
import { IAllstarUser } from "../Setup/Components/@types";
import { TPlayer } from "./@types";

export const formatDate = (date: string) => {
  const parsedDate = /^\d+$/.test(date) // this regex checks if the string is a number
    ? new Date(parseInt(date))
    : new Date(date);
  return parsedDate.toLocaleString("en-us", {
    month: "short",
    day: "numeric",
  });
};
export const formatTime = (time: number) => {
  const date = new Date(time * 1000).toISOString();
  return time > 3600 ? date.substring(11, 19) : date.substring(14, 19);
};
export const formatGameMode = (gameMode: string) =>
  `${gameMode.charAt(0)}${gameMode.slice(1).toLowerCase()}`;
export const formatDuration = (seconds: number) =>
  `${~~(seconds / 60)}:${seconds % 60}`;
export const mustLinkAnAccount = ({
  game,
  allstarUser,
}: {
  game: ESupportedGames;
  allstarUser: IAllstarUser;
}) => {
  switch (game) {
    case ESupportedGames.LOL:
      return !allstarUser?.user?.riot?.active;
    case ESupportedGames.CS2:
      return (
        !allstarUser?.user?.steam?.active &&
        !allstarUser?.user?.faceit?.nickname
      );
    case ESupportedGames.FORTNITE:
      return !allstarUser?.user?.epic?.id;
    case ESupportedGames.NONE:
      return true;

    default:
      return null;
  }
};
export const getPlayerSearchIdentifier = () => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get("playerSearchIdentifier") || "";
};
export const getPlayerGameIdByGame = (
  game: ESupportedGames | undefined,
  user: IAllstarUser,
): string | null => {
  if (!game) return null;
  switch (game) {
    case ESupportedGames.CS2:
      return user?.user?.steam?.steamid ?? null;
    case ESupportedGames.LOL:
      return user?.user?.riot?.puuid ?? null;
    case ESupportedGames.FORTNITE:
      return user?.user?.epic?.id ?? null;

    default:
      return null;
  }
};

export const getMatchHistoryGameEnum = (game?: string | undefined) => {
  if (!game) return ESupportedGames.NONE;
  switch (game) {
    case "COUNTER_STRIKE_2":
    case "CS2":
      return ESupportedGames.CS2;
    case "COUNTER_STRIKE_GO":
      return ESupportedGames.CSGO;
    case "FORTNITE":
      return ESupportedGames.FORTNITE;
    case "DOTA2":
      return ESupportedGames.DOTA2;
    case "LEAGUE_OF_LEGENDS":
    case "LOL":
      return ESupportedGames.LOL;
  }
};
